module.exports = __webpack_public_path__ + "static/img/example_fljn.0d2bee1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/example_fljn.jpg
// module id = ebVH
// module chunks = 128